export function getUnselectedCategoriesWithAttributes({
  categoriesWithAttributes,
  selectedCategories,
}: {
  categoriesWithAttributes: string[];
  selectedCategories: string[];
}): string[] {
  return categoriesWithAttributes.filter(category => !selectedCategories.includes(category));
}
